import './bxh.scss';

interface Props {
    rankList: any[];
    onClose: () => void;
}
export default function MiniRank(props: Props) {
    const { rankList, onClose } = props;
    return (
        <div className="wrapbxh">
            <div id="bxhBC">
                <h3 className="title">TOP THẮNG CƯỢC</h3>
                <div className="btnCloseBXH" onClick={onClose}>
                    <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                </div>

                <table className="tblTop">
                    <thead>
                        <tr>
                            <td>Xếp Hạng</td>
                            <td>Tên Tài Khoản</td>
                            <td>Số Tiền Thắng</td>
                        </tr>
                    </thead>
                </table>

                <div className="wrapTbl">
                    <div className="tblBottomScroll">
                        <table className="tblBottomScroll">
                            <tbody>
                                {rankList.map((item, index) => (
                                    <tr key={index}>
                                        {index === 0 && <td>
                                            <img className="win-1" src={require(`assets/images/txcanban/hang-1.png`)} alt="" />
                                        </td>}
                                        {index === 1 && <td>
                                            <img className="win-2" src={require(`assets/images/txcanban/hang-2.png`)} alt="" />
                                        </td>}
                                        {index === 2 && <td>
                                            <img className="win-3" src={require(`assets/images/txcanban/hang-2.png`)} alt="" />
                                        </td>}
                                        {index > 2 && <td>{index + 1}</td>}
                                        <td>{ item["loginname"] }</td>
                                        <td>{ new Intl.NumberFormat().format(item["amount"]) }</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}